import { render, staticRenderFns } from "./High.vue?vue&type=template&id=bc10c4c0"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc10c4c0')) {
      api.createRecord('bc10c4c0', component.options)
    } else {
      api.reload('bc10c4c0', component.options)
    }
    module.hot.accept("./High.vue?vue&type=template&id=bc10c4c0", function () {
      api.rerender('bc10c4c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/PriorityIcons/High.vue"
export default component.exports